import React, { useState, useEffect } from 'react';
import { IFeatureProps } from 'mod/featureV2/interface';
import { IFeatureWaterFall } from 'mod/featureV2/interface/waterFall';
import { FeatureContainer } from 'mod/featureV2/FeatureContainer';
import { IOldBanner } from 'mod/featureV2/interface/banner'
import { Image } from '@base/lib/ThemeImage'
import { useTrans } from 'base/utils/i18n';
import { get375CssValue } from 'base/utils/dom-size';

const CONTAINER_WIDTH = process.env.NEXT_PUBLIC_TERMINAL === 'm' ? 375 : 1200; //容器最大宽度

export const FeatureWaterFall: React.FC<IFeatureProps<IFeatureWaterFall>> = (props) => {
    const [pageNum, setPageNum] = useState<number>(1)
    const [showList, setShowList] = useState<IOldBanner[][]>([])
    const { t } = useTrans();

    const {
        config: {
            column = 2,
            height = 200,
            spaceBetweenColumns = 20,
            viewMoreText = `${t('web_common_view_more')} >`,
            pageSize = 6,
        },
        list,
    } = props.feature;

    const imageWidth = Math.round((CONTAINER_WIDTH + spaceBetweenColumns) / column) - spaceBetweenColumns;
    const imageHeight = height || 200;
    const fullColumnSpace = get375CssValue(spaceBetweenColumns);
    const halfColumnSpace = get375CssValue(spaceBetweenColumns / 2);

    // 分成几组
    const columnLengthArr = Array.from({ length: column }, (_, i) => i);

    const getShowList = () => {
        let _showList = list.slice(0, pageNum * pageSize)
        // 将list分成 column 组
        const columnList = columnLengthArr.map((_groupItem, groupIndex) => {
            return _showList.map((item, lIndex) => {
                return { ...item, lIndex }
            }).filter((lItem, lIndex) => {
                return lIndex % column == groupIndex
            })
        })

        setShowList(columnList)
    }

    useEffect(() => {
        getShowList()
    }, [pageNum])

    return (
        <FeatureContainer {...props}>
            <div className={process.env.NEXT_PUBLIC_TERMINAL === 'm' ? 'g-wrapper-full' : 'g-wrapper'}>
                <div
                    className={'g-list'}
                    style={{
                        marginLeft: `-${halfColumnSpace}`,
                        marginRight: `-${halfColumnSpace}`,
                        rowGap: fullColumnSpace
                    }}
                >
                    {showList?.map((cItem, cIndex) => (
                        <div
                            key={cIndex}
                            className={`column${cIndex}`}
                            style={{
                                width: `${100 / column}%`,
                                paddingLeft: halfColumnSpace,
                                paddingRight: halfColumnSpace,
                            }}
                        >
                            {cItem?.map((item, index) => {
                                return (
                                    <div
                                        key={`${cIndex}_${index}`}
                                        style={{
                                            marginTop: index != 0 ? fullColumnSpace : 0
                                        }}
                                    >
                                        <Image
                                            className={'pointer'}
                                            href={item.linkUrl}
                                            fit={'cover'}
                                            src={item.picUrl}
                                            width={imageWidth}
                                            height={(cIndex % 2 == 1 && index == 0) ? imageWidth : imageHeight}
                                        />
                                    </div>
                                )
                            })}
                        </div>

                    ))}
                </div>

                {pageNum * pageSize < list.length && (
                    <div className={'g-view-more-wrap text-center'}>
                        <span
                            className={'g-view-more text-center pointer'}
                            onClick={() => setPageNum(pageNum + 1)}
                        >
                            {viewMoreText}
                        </span>
                    </div>
                )}

            </div>
        </FeatureContainer>
    );
};